import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23d59993"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-edit edit" }, null, -1))
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { class: "members" }
const _hoisted_6 = { style: {"display":"grid","grid-template-columns":"repeat(auto-fit, 80px)","grid-template-rows":"repeat(auto-fit, 80px)","grid-row-gap":"20px","grid-column-gap":"20px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-user" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-add" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = { class: "username" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-close" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

import { getCurrentInstance, reactive, ref, toRefs } from "vue";
import { useUserStore } from "@/store/userStore";
import { useChatStore } from "@/store/chatStore";
import { useRoute, useRouter } from "vue-router";
import type { ElForm } from "element-plus";
import { ElMessage, ElMessageBox } from "element-plus";

import Avatar from "@/components/Avatar.vue";
import AddGroupUser from "@/views/group/AddGroupUser.vue";
import AvatarUpload from "@/components/AvatarUpload.vue";
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
import GroupApi from "@/api/GroupApi";
import User from "@/mode/User";
import showUser from "@/components/user-modal/";
import { useGroupStore } from "@/store/groupStore";
import ChatType from "@/config/ChatType";
import Group from "@/mode/Group";
import Message from "@/mode/Message";
import MessageType from "@/utils/MessageType";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
interface VimData {
  host: string;
  headers: any;
  needCheck: boolean;
  data: any;
  users: Array<User>;
  show: boolean;
  userId: string;
  isMaster: boolean;
  drawer: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Info',
  setup(__props) {

const { proxy } = getCurrentInstance();

const ruleFormRef = ref<InstanceType<typeof ElForm>>();
const groupStore = useGroupStore();
const router = useRouter();
const userStore = useUserStore();
const chatStore = useChatStore();
const route = useRoute();

const dataForm = reactive<Group>({
  id: "",
  name: "",
  needCheck: "",
  avatar: "/img/default-group.png",
  master: "",
});

const rules = reactive({
  name: [
    {
      required: true,
      message: "必填",
      trigger: "blur",
    },
    {
      min: 3,
      max: 10,
      message: "长度介于3-10",
      trigger: "blur",
    },
  ],
});
const vimData = reactive<VimData>({
  host: FetchRequest.getHost(),
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
  data: {
    access_token: Auth.getToken(),
    type: "file",
  },
  needCheck: false,
  users: new Array<User>(),
  show: false,
  userId: "",
  //是否是群管理员
  isMaster: false,
  //是否展示添加用户(抽屉)
  drawer: false,
});
const groupId = route.params.id;
if (typeof groupId === "string") {
  GroupApi.get(groupId)
    .then((res) => {
      dataForm.avatar = res.data.avatar;
      dataForm.id = res.data.id;
      dataForm.name = res.data.name;
      dataForm.master = res.data.master;
      dataForm.needCheck = res.data.needCheck;
      vimData.isMaster = res.data.master === userStore.user?.id;
      loadUser();
    })
    .catch((err) => {
      ElMessage.error(err.message);
    });
}
//加载群用户
const loadUser = () => {
  vimData.users.splice(0, vimData.users.length);
  if (typeof groupId === "string") {
    GroupApi.users(groupId).then((res) => {
      vimData.drawer = false;
      res.data.forEach((item: User) => {
        vimData.users.push(item);
      });
    });
  }
};

const uploadSuccess = (url: string) => {
  dataForm.avatar = url;
};

const exit = () => {
  if (typeof groupId === "string") {
    GroupApi.exit(groupId).then((res) => {
      if (res) {
        groupStore.reloadGroupList();
        notify(dataForm.master, groupId, userStore.user?.name + " 退出了群聊");
        ElMessage.success("退群成功!");
        router.push("/index/group/new");
      } else {
        ElMessage.error("退群失败");
      }
    });
  }
};

const updateGroup = () => {
  ruleFormRef.value?.validate((f) => {
    if (f) {
      GroupApi.update(
        dataForm.id,
        dataForm.name,
        dataForm.avatar,
        dataForm.needCheck ? "1" : "0"
      )
        .then(() => {
          groupStore.reloadGroupList();
          ElMessage.success("保存成功");
        })
        .catch(() => {
          ElMessage.error("保存失败");
        });
    }
  });
};

const addUser = () => {
  vimData.drawer = true;
};
//从群众删除拥护
const deleteUser = (userId: string) => {
  ElMessageBox.confirm("是否从群中删除此人?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    if (typeof groupId === "string") {
      GroupApi.deleteUser(groupId, userId).then((res) => {
        if (res) {
          loadUser();
          ElMessage.success("删除成功!");
        } else {
          ElMessage.error("删除失败");
        }
      });
    }
  });
};

const deleteGroup = () => {
  ElMessageBox.confirm("是否解散此群?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    if (typeof groupId === "string") {
      GroupApi.delete(groupId).then((res) => {
        if (res) {
          groupStore.reloadGroupList();
          notify(dataForm.master, groupId);
          ElMessage.success("解散成功!");
          router.push("/index/group/new");
        } else {
          ElMessage.error("解散失败");
        }
      });
    }
  });
};

/**
 * 通知用户群已经被删除
 * @param master 群主id
 * @param groupId 群id
 * @param content content
 */
const notify = (master: string, groupId: string, content = "群已被解散") => {
  if (master) {
    let msg: Message = {
      chatId: groupId,
      fromId: master,
      mine: true,
      messageType: MessageType.text,
      content: content,
      timestamp: new Date().getTime(),
      type: ChatType.GROUP,
    };
    proxy.$ws.sendMessage(msg);
  }
};

/**
 * 打开聊天室
 */
const openChat = () => {
  chatStore.openChat({
    id: dataForm.id,
    name: dataForm.name,
    avatar: dataForm.avatar,
    type: ChatType.GROUP,
    lastMessage: "",
    unreadCount: 0,
    isLoading: false,
    loaded: true,
  });
  router.push("/index/chat");
};

const { users, show, userId, isMaster, drawer } = toRefs(vimData);

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(isMaster))
          ? (_openBlock(), _createBlock(AvatarUpload, {
              key: 0,
              avatar: dataForm.avatar,
              onUploadSuccess: uploadSuccess
            }, null, 8, ["avatar"]))
          : _createCommentVNode("", true),
        (!_unref(isMaster))
          ? (_openBlock(), _createBlock(Avatar, {
              key: 1,
              img: "dataForm.avatar",
              size: "large"
            }))
          : _createCommentVNode("", true),
        _hoisted_3
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          inline: true,
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: dataForm,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "群名称:",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: dataForm.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.name) = $event)),
                  readonly: !_unref(isMaster)
                }, null, 8, ["modelValue", "readonly"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createElementVNode("div", null, [
          (_unref(isMaster))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: updateGroup,
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isMaster))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                onClick: deleteGroup,
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("解散")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_unref(isMaster))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                onClick: exit,
                type: "danger"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("退出")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            onClick: openChat,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("聊天")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_el_divider),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_unref(isMaster))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (addUser())),
              class: "user user-box"
            }, _hoisted_8))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(users), (user) => {
          return (_openBlock(), _createElementBlock("div", {
            key: user.id,
            class: "user user-box",
            onClick: ($event: any) => (_unref(showUser)(user.id, true)),
            title: user.name
          }, [
            _createVNode(Avatar, {
              img: user.avatar,
              name: user.name
            }, null, 8, ["img", "name"]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(user.name), 1),
            (user.id !== dataForm.master && _unref(isMaster))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "close",
                  onClick: _withModifiers(($event: any) => (deleteUser(user.id)), ["stop"])
                }, _hoisted_13, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ], 8, _hoisted_9))
        }), 128))
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _unref(drawer),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(drawer) ? (drawer).value = $event : null)),
      title: "添加群成员",
      size: "50%",
      direction: "rtl"
    }, {
      default: _withCtx(() => [
        (_unref(drawer))
          ? (_openBlock(), _createBlock(AddGroupUser, {
              key: 0,
              group: dataForm,
              onReload: loadUser
            }, null, 8, ["group"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})